import { render } from "./header_culinary.vue?vue&type=template&id=60b8cf7d"
import script from "./header_culinary.vue?vue&type=script&lang=js"
export * from "./header_culinary.vue?vue&type=script&lang=js"

import "./header_culinary.vue?vue&type=style&index=0&id=60b8cf7d&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__